/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-23 13:17:28
 * @Explain: 活动
 */
import { ToTabsEnum } from '@/pages/activityManage/create/data.d';
import http from '../http';
// type
import type { FilterFormType } from '@/pages/segmentsManage/utils/typings/addOrEdit';
// utils
import { isArrayLen, isObjectLen } from '@/utils/common/dataJudgment';
import { jsonStringify } from '@/utils/global';
import httpV2 from '../http-v2';

const MODEL = '/task';
const NEW_MODEL = '/filter_group';
const IGNORE_CONVERTED_KEY = 'attributes';

export default {
  // 获取活动列表 - （进行中、暂停、已完成）
  getCampaignsList(data: Record<any, any>) {
    return http.post(`${MODEL}/get_campaigns`, data);
  },
  // 获取列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/get-list`, data);
  },
  // 获取当前活动 - 国家列表
  getCountryData(data: Record<any, any>) {
    return http.post(`${MODEL}/task_country_data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/create-campaign`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update-campaign`, data);
  },
  // 保存草稿
  onSaveDraft(data: Record<any, any>) {
    return http.post(`${MODEL}/save-draft`, data);
  },
  // 更新活动类型
  updateActivityType(data: Record<any, any>) {
    return http.post(`${MODEL}/update-campaign-type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取活动类型配置
  getActivityTypeConfig(data: Record<any, any>) {
    return http.post(`${MODEL}/get-campaign-type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 验证标题是否重复
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check-campaign-title-existing`, data);
  },
  // 获取详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get-campaign-detail`, data);
  },
  // 获取周期修改记录
  getCycleModifyRecord(data: Record<any, any>) {
    return http.post(`${MODEL}/get_timelines`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取周期详情
  getCycleDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get_periods`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取上次提交活动的详情
  getLastDetails() {
    return http.post(`${MODEL}/get-latest-campaign-info`);
  },
  // 验证邮件模板
  checkTemplate(data: Record<any, any>) {
    return http.post(`${MODEL}/check-template`, data);
  },
  // 获取审批人列表
  getApproverList(data: Record<any, any>) {
    return http.post(`${MODEL}/get-check-users`, data);
  },
  // 审批
  onApproval(data: Record<any, any>) {
    return http.post(`${MODEL}/check-activity`, data);
  },
  // 审批 - 催办
  onApprovalUrge(data: Record<any, any>) {
    return http.post(`${MODEL}/reminder-check-user`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data);
  },
  // 撤销
  onRevoke(data: Record<any, any>) {
    return http.post(`${MODEL}/cancel-check`, data);
  },
  // 开始活动
  onStart(data: Record<any, any>) {
    return http.post(`${MODEL}/required`, data);
  },
  // 暂停活动
  onSuspend(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend`, data);
  },
  // 终止活动
  onTermination(data: Record<any, any>) {
    return http.post(`${MODEL}/stop`, data);
  },
  // 发送测试邮件
  onSendTestMail(data: Record<any, any>) {
    return http.post(`${MODEL}/test-campaign`, data);
  },
  // 获取选择活动（标签、分层）规则，详情
  getRuleDetails(data: {
    segmentType: number;
    segmentId: string;
    taskId?: number;
    taskUuid?: number;
    deliveryChannel?: number;
    // 分层信息
    relation?: string;
    name?: string;
    filters?: FilterFormType[];
  }) {
    // 根据分层ID获取统计
    if (data.segmentType === ToTabsEnum.Segment) {
      return http.post(`${MODEL}/seg-detail`, data);
    }
    // 其它方式获取统计信息（标签、订阅状态）
    if (data.segmentType && data.segmentType !== ToTabsEnum.builtinSegment) {
      return http.post(`${MODEL}/preview-user-detail`, data);
    }

    // 查找来源条件项
    const sourceFilterItem: FilterFormType | undefined = data?.filters?.find(
      (item) => item?.key === 'source',
    );
    // 来源条件中: 参数不做驼峰和下划线互转换的key
    const ignoreConvertedKey =
      sourceFilterItem?.extendData && isObjectLen(sourceFilterItem?.extendData)
        ? Object.keys(sourceFilterItem?.extendData)
        : [];
    if (isArrayLen(ignoreConvertedKey)) {
      // 加入时间: 参数不做驼峰和下划线互转换的key
      ignoreConvertedKey.push('joinTime');
      // 加入渠道: 参数不做驼峰和下划线互转换的key
      ignoreConvertedKey.push('joinChannel');
    }
    // 根据具体分层条件信息获取统计
    return http.post(`${NEW_MODEL}/preview_builtin_segment`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: jsonStringify(ignoreConvertedKey),
      },
    });
  },
  // 撤销 - 已计划列表操作项
  onRevokeScheduled(data: Record<any, any>) {
    return http.post(`${MODEL}/revoke`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  checkAttribute(data: Record<any, any>) {
    return httpV2.post(`${MODEL}/check_attribute`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([IGNORE_CONVERTED_KEY]),
        ignoreConvertedValueKey: JSON.stringify([IGNORE_CONVERTED_KEY]),
      },
    });
  },
};
